import type { ZoneTreeDto } from "~/core/types/zone";

export const zoneHome: ZoneTreeDto = {
  id: -1,
  value: "-1",
  label: "Trang chủ",
  name: "Trang chủ",
};

export const localStorageKey = {
    searchOptions: "search_options",
  
};
